




































import { Vue, Component, Prop, Watch } from "vue-property-decorator";

import ImageSwitcher from "./ImageSwitcher.vue";
import EmptyPreviewImage from "./emptyPreviewImage.vue";

// Enums/Data
import { BASE_URL } from "@/store/modules/api";

// Types
import { IGalleryImageType } from "@/models/images";
import { IImage } from "@/store/types";

@Component({
  components: {
    "image-switcher": ImageSwitcher,
    "empty-image": EmptyPreviewImage
  }
})
export default class ImageGallery extends Vue {
  @Prop({ required: true })
  public images!: IGalleryImageType[];

  @Prop({ default: 8 })
  public limit!: number;

  @Prop({ required: true })
  public reorder!: Function;

  @Prop({ required: true })
  public refresh!: Function;

  @Prop({ required: true })
  public isLoading!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  public previewImage = {} as IGalleryImageType;

  public setPreviewImage(image = {} as IGalleryImageType) {
    if (!this.$_.isEmpty(image)) {
      this.previewImage = image;
      return;
    }

    if (!this.$_.isEmpty(this.defaultImage)) {
      this.previewImage = this.defaultImage;
      return;
    }

    this.previewImage = this.$_.get(
      this.$_.filter(this.images, ["exists", true]),
      "[0]",
      {}
    );
  }

  public showPreview(image = {} as IGalleryImageType) {
    this.setPreviewImage(image);
  }

  public get defaultImage() {
    const image = this.$_.find(this.images, ["default", true]);
    return image ? image : ({} as IGalleryImageType);
  }

  public newImages(images, imageId) {
    this.$emit("newImages", images, imageId);
  }

  public deleteImage(imageId: IImage["id"]) {
    this.$emit("deleteImage", imageId);
  }

  public setDefault(imageId: IImage["id"]) {
    this.$emit("setDefault", imageId);
  }

  public imageIsVisible(imageIndex: number) {
    return (
      this.$_.get(this.images, `[${imageIndex}].id`) ===
        this.$_.get(this.previewImage, "id") &&
      imageIndex < (this.images ? this.images.length : 0)
    );
  }

  private getSrc(imageIndex) {
    return (this.images ? this.images.length : 0) > imageIndex
      ? `url(${BASE_URL}api/images/${this.$_.get(
          this.images,
          `[${imageIndex}].hash`
        )}/download?size=400x400)`
      : "";
  }

  @Watch("images", { immediate: true })
  public onImagesChange() {
    this.setPreviewImage();
  }
}
